<template>
	<div>
		<div v-if="sent === false" class="unauth-form">
			<div class="unauth-form-container">
				<form @submit.prevent="onSubmit">

					<div class="title-container">
						<div class="title">Forgot Password</div>
						<div class="buttons">
							<router-link to="/login" class="button"><div class="hover-title">Cancel</div><span class="fa fa-times"></span></router-link>
						</div>
					</div>

					<form-errors :errors="errors"></form-errors>

					<div class="conjoin-input-containers">
						<field-errors v-if="submitAttempted" :form="$v.form" field="email"></field-errors>
						<div class="input-container">
							<div class="input-title">Account Email</div>
							<div class="input-box"><input type="text" v-model="form.email"></div>
						</div>
					</div>
					<submit-button text="Send Password Reset" icon="fa-paper-plane" :loading="formSaving" :has-errors="hasErrors"></submit-button>
				</form>
			</div>
			<div class="unauth-decor">
				<div class="logo">
					<span class="fak fa-gravity-fox"></span>
				</div>
			</div>
		</div>
		<div v-else class="unauth-form">
			<div class="unauth-form-container">
				<div class="title-container">
					<div class="title">Reset Link Sent</div>
				</div>
				<div class="input-container">
					<div class="input-static-text">We have sent you an email with a link to reset your password. Please check your email and follow the instructions you received.<br><br><b>If you did not receive the email in your inbox, please check your SPAM folder.</b></div>
				</div>
			</div>
			<div class="unauth-decor">
				<div class="logo">
					<span class="fak fa-gravity-fox"></span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import FormMixin from '@/mixins/FormMixin';
import { required, email } from 'vuelidate/lib/validators';

export default {

	name: 'ForgotPasswordPage',

	mixins: [ FormMixin ],

	data() {
		return {
			form: {},
			sent: false,
			errors: {},
		};
	},

	validations: {
		form: {
			email: { required, email },
		},
	},

	methods: {

		async onSubmit() {
			this.submit(async () => {
				await this.$api.post('/password/email', this.form);

				this.sent = true;
			});
		},

	}
};

</script>
